import React from 'react';

import { PersonaQuizBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpPersonaQuizBlock({
  content,
  data,
  blockId,
}: AmpBlockMappingComponentProps<PersonaQuizBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      data={{
        ...data,
        text: data.questions[0].title,
        // @ts-expect-error Fix me
        image: data.questions[0].image,
        buttonText: getText('View Quiz'),
      }}
      blockId={blockId}
    />
  );
}
